import type { ReactNode } from 'react';
import { cx } from './utils';

export interface DataTableFooterShellProps {
    children: ReactNode;
    /** Rendered at the end of the row - the mode toggle, when there is one. */
    trailing?: ReactNode;
    className?: string;
    /** Set on a `role="navigation"` wrapper; omit for a non-navigational footer. */
    ariaLabel?: string;
}

/**
 * Shared chrome for the table footer - the same border/padding/rounding
 * whether the content is a pager, a loaded-vs-total count, or a plain row
 * count, so the footer looks identical across all three regardless of which
 * `DataTable` mode produced it.
 */
export function DataTableFooterShell({
    children,
    trailing,
    className,
    ariaLabel
}: DataTableFooterShellProps) {
    return (
        <div
            role={ariaLabel ? 'navigation' : undefined}
            aria-label={ariaLabel}
            className={cx(
                'flex items-center justify-between gap-4 px-6 py-4 border-t border-gray-200 rounded-b-xl bg-white shrink-0',
                className
            )}
        >
            <div className="flex items-center">{children}</div>
            {trailing}
        </div>
    );
}
